(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sticky-bottom-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var stickyBar  = document.getElementById('stickyCartBanner');
    var mainButton = document.getElementById('crudo-buy-now-btn'); // cart-drawer powered button

    if (!stickyBar) return;

    // Show/hide sticky bar based on main button visibility
    window.addEventListener('scroll', function() {
      if (mainButton) {
        var rect = mainButton.getBoundingClientRect();
        if (rect.bottom < 0) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
      } else {
        if (window.scrollY > 400) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
      }
    });

    // Wire sticky Buy It Now button to scroll to top hero section
    var stickyBuyBtn = stickyBar.querySelector('.crudo-panel-btn, .gokwik-checkout');
    if (stickyBuyBtn) {
      stickyBuyBtn.addEventListener('click', function(e) {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
